// extracted by mini-css-extract-plugin
export default {"tag":"WEsVnBmET6Hkf_w9PCut","date":"PLXT6YJP7Wo1QYz0ieOC","label":"ehVLAxkDKGxhqLaXnWKg"};